module.exports = __webpack_public_path__ + "img/1545388928.2e6070b7.jpg";